import { FilterStatus } from '../../enums/FilterStatus';
import { Severity } from '../../enums/Severity';

export class Instance {
  constructor(
    private readonly id: number,
    private readonly severity: Severity,
    private readonly data: string,
    private readonly filterStatus: FilterStatus,
    private readonly instanceNumber: number,
    private readonly numberLocal: number,
    private readonly ruleNumber: number
  ) {}

  getId() {
    return this.id;
  }

  getSeverity() {
    return this.severity;
  }

  getData() {
    return this.data;
  }

  getFilterStatus() {
    return this.filterStatus;
  }

  getNumber() {
    return this.instanceNumber;
  }

  getNumberLocal() {
    return this.numberLocal;
  }

  getIssueNumber() {
    return this.ruleNumber;
  }
}
